
import {
    USE_BRANDING,
    SET_BRANDING,
} from "./actionType";

const initialState = {
    branding: false,
};

const brandingReducer = (state = initialState, action) => {
    switch (action.type) {
        case USE_BRANDING:
            return {
                ...state,
            };
        case SET_BRANDING:
            return {
                ...state,
                branding: action.payload,
            };
        default:
            return state;
    }
};

export default brandingReducer;
